import { render, staticRenderFns } from "./articleProduct.vue?vue&type=template&id=4c0c5f3d&scoped=true&"
import script from "./articleProduct.vue?vue&type=script&lang=js&"
export * from "./articleProduct.vue?vue&type=script&lang=js&"
import style0 from "./articleProduct.vue?vue&type=style&index=0&id=4c0c5f3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c5f3d",
  null
  
)

export default component.exports